// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const buizel: PokeData = {
  "id": 418,
  "name": "buizel",
  "height": 7,
  "weight": 295,
  "base_experience": 66,
  "types": [
    PokeType.WATER
  ],
  "api_moves": [
    "razor-wind",
    "tackle",
    "tail-whip",
    "bite",
    "growl",
    "sonic-boom",
    "water-gun",
    "hydro-pump",
    "agility",
    "quick-attack",
    "waterfall",
    "swift",
    "pursuit",
    "whirlpool",
    "water-sport",
    "water-pulse",
    "aqua-tail",
    "aqua-jet",
    "double-hit",
    "soak",
    "liquidation",
    "wave-crash"
  ],
  "moves": [
    "tackle",
    "bite",
    "growl",
    "hydro-pump",
    "quick-attack",
    "pursuit",
    "whirlpool",
    "aqua-tail",
    "aqua-jet",
    "liquidation",
    "rain-dance",
    "water-spout",
    "life-dew"
  ],
  "evolution_chain": {
    "id": 216,
    "item": null,
    "species": [
      {
        "name": "buizel",
        "order": 446,
        "types": [
          PokeType.WATER
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "floatzel",
        "order": 447,
        "types": [
          PokeType.WATER
        ],
        "evolves_from_species_id": 418,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 26,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 43.75,
    "speed": 85,
    "ability_power": 65
  },
  "stat_changes": [],
  "catch_rate": 190,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
